module.exports = __webpack_public_path__ + "static/media/6COPUOS3.7302dc10.jpg";